import React, { useState } from 'react';
import { Modal, Button, Form, Spinner } from 'react-bootstrap';
import { toast } from 'react-toastify';
import api from '../../services/api';

const BonusModal = ({ show, handleClose }) => {
    const [requestId, setRequestId] = useState('');
    const [transactionType, setTransactionType] = useState('bonus'); // "bonus" or "incentive"
    const [amount, setAmount] = useState('');
    const [loading, setLoading] = useState(false);

    // Reset form fields when the modal closes.
    const onHide = () => {
        setRequestId('');
        setTransactionType('bonus');
        setAmount('');
        handleClose();
    };

    const handleSubmit = async () => {
        setLoading(true);
        try {
            const payload = {
                request_id: requestId,
                type: transactionType, // should be either "bonus" or "incentive"
                amount,              // amount as provided by input
                inOrOut: 'in',       // fixed value for bonus/incentive transactions
            };

            // Adjust the endpoint as needed.
            const response = await api.post('/transaction/bonus', payload);
            if (response.status === 200) {
                toast.success('Bonus/Incentive added successfully!');
                onHide();
            } else {
                toast.error('Failed to add bonus');
            }
        } catch (error) {
            console.error('Error creating transaction:', error);
            toast.error(
                error.response?.data?.message || 'Error creating transaction'
            );
        }
        setLoading(false);
    };

    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton>
                <Modal.Title>Add Bonus/Incentive</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form.Group className="mb-3">
                    <Form.Label>CIL ID</Form.Label>
                    <Form.Control
                        type="text"
                        placeholder="Enter CIL ID"
                        value={requestId}
                        onChange={(e) => setRequestId(e.target.value)}
                    />
                </Form.Group>
                <Form.Group className="mb-3">
                    <Form.Label>Transaction Type</Form.Label>
                    <Form.Control
                        as="select"
                        value={transactionType}
                        onChange={(e) => setTransactionType(e.target.value)}
                    >
                        <option value="bonus">Bonus</option>
                        <option value="incentive">Incentive</option>
                    </Form.Control>
                </Form.Group>
                <Form.Group className="mb-3">
                    <Form.Label>Amount</Form.Label>
                    <Form.Control
                        type="number"
                        placeholder="Enter amount"
                        value={amount}
                        onChange={(e) => setAmount(e.target.value)}
                    />
                </Form.Group>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    Close
                </Button>
                <Button variant="primary" onClick={handleSubmit} disabled={loading}>
                    {loading ? <Spinner animation="border" size="sm" /> : 'Submit'}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default BonusModal;
